import { render, staticRenderFns } from "./questionRegister.vue?vue&type=template&id=316d62c6&scoped=true"
import script from "./questionRegister.vue?vue&type=script&lang=js"
export * from "./questionRegister.vue?vue&type=script&lang=js"
import style0 from "./questionRegister.vue?vue&type=style&index=0&id=316d62c6&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316d62c6",
  null
  
)

export default component.exports